module.exports = __webpack_public_path__ + "static/media/footerFebrero.9715adf5.jpg";